import Component from '@cell/cell-core/component/component';
import './filter-value.scss';

class FilterValue extends Component {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input'),
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.elements.input.on('change', this.handleInputChange);
  }

  handleInputChange(event) {
    const { checked } = this.elements.input;

    if (checked) {
      this.emit('add', {
        url: this.parsedDataset.urlToAdd,
      });
    } else {
      this.emit('remove', {
        url: this.parsedDataset.urlToRemove,
      });
    }
  }

  setLoading() {
    this.classList.add('FilterValue--Loading');
  }
}

customElements.define('filter-value', FilterValue);
